<div class="it-services-banner-area ">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="it-services-banner-content">
                    <h1>DevOps</h1>
                    <P>On top of the software development services, Techfidelite Solutions provides DevOps person to manage the ideal deployments and all the cloud requirements(AWS) to complete the circle of Software System Development. </P>
                    <div class="btn-box">
                        <a routerLink="/contact" class="default-btn">Get in Touch</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="it-services-banner-image">
                    <img
                        src="assets/img/it-services-home/devops.jpg"
                        alt="image"
                    />
                </div>
            </div>
        </div>
    </div>
</div>
 <div class="features-style-area mb-3">
    <div class="container">
        <div class="features-style-inner-box">
            <div class="row justify-content-center">
                <div class="col-lg-4 col-md-6">
                    <div class="features-style-card text-center">
                        <div class="features-image">
                            <img src="assets/fonts/aws.png" width="122px" height="122px" alt="image">
                        </div>
                        <div class="features-content">
                            <h3>AWS</h3>
                         
                        </div>        
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features-style-card text-center">
                        <div class="features-image">
                            <img src="assets/img/svg-logo/future.webp
                            " width="122px" height="122px" alt="image">
                        </div>
                        <div class="features-content">
                            <h3>Security</h3>
                       
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features-style-card text-center">
                        <div class="features-image">
                            <img src="assets/img/svg-logo/data-analysis.webp" width="122px" height="122px" alt="image">
                        </div>
                        <div class="features-content">
                            <h3>Data Analytics</h3>
                        
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> 
<!-- <section class="working-process-area ptb-110 pb-110">
    <div class="container">
        <div class="section-title-style-two">
            <div class="content">
                <span>Our Process</span>
                <h2>Development Stages of MVP Development</h2>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-working-process-box">
                    <div class="icon">
                        <img src="assets/img/icon1.png" alt="image">
                    </div>
                    <h3><a href="#">Requirement Analysis</a></h3>
                    <p>To analyze our client's needs, we prioritize documentation first for clarity and better understanding on both sides.</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-working-process-box">
                    <div class="icon">
                        <img src="assets/img/icon2.png" alt="image">
                    </div>
                    <h3><a href="#">Development</a></h3>
                    <p>With client approval, we begin the development process with the technologies most suited for you and provide results within the timeframe.</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                <div class="single-working-process-box">
                    <div class="icon">
                        <img src="assets/img/icon3.png" alt="image">
                    </div>
                    <h3><a href="#">Planning</a></h3>
                    <p>A well-planned architecture provides a clear understanding and identifies the talents required in your application development program.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                <div class="single-working-process-box">
                    <div class="icon">
                        <img src="assets/img/icon3.png" alt="image">
                    </div>
                    <h3><a href="#">Design</a></h3>
                    <p>We assist our clients in developing engaging and interesting UI designs that explain the user-friendly flow of a website/app/platform. </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                <div class="single-working-process-box">
                    <div class="icon">
                        <img src="assets/img/icon3.png" alt="image">
                    </div>
                    <h3><a href="#">Testing</a></h3>
                    <p>Performing complete Quality assurance (QA) during the development process makes the applications reliable, accessible, and secure.</p>
                </div>
            </div>
                
         
            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                <div class="single-working-process-box">
                    <div class="icon">
                        <img src="assets/img/icon3.png" alt="image">
                    </div>
                    <h3><a href="#">Deployment</a></h3>
                    <p>We are prepared to assist our clients with final testing, UAT, training, and final deployment of the source code and platform launch.</p>
                </div>
            </div>
        </div>
    </div>
</section> -->
<!-- <div class="about-wrap-area pt-110 pb-110">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="about-wrap-image">
                    <img src="assets/img/it-services-home/about.png" alt="image">
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="about-wrap-content">
                    <h3>Technology Used With Mvp</h3>
                    <div class="row justify-content-center">
                        <div class="col-lg-6 col-sm-6">
                            <ul class="wrap-list">
                                <li><i class="fa-solid fa-check-double"></i>Swift</li>
                                <li><i class="fa-solid fa-check-double"></i>Java</li>
                                <li><i class="fa-solid fa-check-double"></i>Aws</li>
                            </ul>
                        </div>
                        <div class="col-lg-6 col-sm-6">
                            <ul class="wrap-list">
                                <li><i class="fa-solid fa-check-double"></i>Database</li>
                                <li><i class="fa-solid fa-check-double"></i>React</li>
                                <li><i class="fa-solid fa-check-double"></i>Node js</li>

                            </ul>
                        </div>
                    </div>
                 
                </div>
            </div>
        </div>
    </div>
</div>
<section class="testimonials-wrap-area ptb-110">
    <div class="container">
        <div class="section-title-style-two">
            <div class="content">
                <h2>What People Say After Using Our Services</h2>
            </div>

        </div>
        <div class="testimonials-wrap-slides owl-carousel owl-theme">
            <div class="single-testimonials-card">
                <p >My experience with Techfidelite software solutions has been
                    very pleasing. Worked with them on multiple projects and had a hassle free experience
                    till date. They quickly respond to change requests and they are awesome.

                </p>
                <div class="client-info d-flex align-items-center justify-content-center">
                    <img src="assets/img/author1.jpg" alt="image">

                    <div class="title">
                        <h3>Ansul jain</h3>
                        <span>Bangalore</span>
                    </div>
                </div>
            </div>

            <div class="single-testimonials-card">
                <p >Techfidelite helped Bee to shape up the on demand service
                    application . The
                    team contribution
                    and client engagement is top notch . I would highly recommend techfidelite to others
                    for digitalization of their businesses</p>
                <div class="client-info d-flex align-items-center justify-content-center">
                    <img src="assets/img/author2.jpg" alt="image">

                    <div class="title">
                        <h3>Selva kumar</h3>
                        <span>Marketing</span>
                    </div>
                </div>
            </div>

            <div class="single-testimonials-card">
                <p >Good live support with projects. Requirement gathering and
                    understanding of projects are good. You can expect commitment from them.</p>
                <div class="client-info d-flex align-items-center justify-content-center">
                    <img src="assets/img/author3.jpg" alt="image">

                    <div class="title">
                        <h3>Roshini</h3>
                        <span>Designer</span>
                    </div>
                </div>
            </div>
            <div class="single-testimonials-card">
                <p >Good live support with projects. Requirement gathering and
                    understanding of projects are good. You can expect commitment from them.</p>
                <div class="client-info d-flex align-items-center justify-content-center">
                    <img src="assets/img/author3.jpg" alt="image">

                    <div class="title">
                        <h3>Surya</h3>
                        <span>Designer</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="testimonials-wrap-map">
        <img src="assets/img/it-services-home/map.png" alt="image">
    </div>
</section> -->
<!-- 
<section class="faq-area ptb-110">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12"> 
                <div class="faq-content">
                    <div class="section-title">
                        <div class="content">
                            <span>Ask Question</span>
                            <h2>Frequently Asked Questions</h2>
                            </div>
                    </div>
                </div>   
                <div class="faq-accordion">
                    <ul class="accordion">
                         
                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                Why develop the MVP with the Techfidelite Team?
                            </a>
                            <p class="accordion-content">The main concern at the idea stage is determining how long it will take to produce an MVP and how much it will cost. Most of our clients want answers to those concerns before they begin, and we are happy to supply them. With MVP development on a particular project, you hand over the whole project execution to another company.</p>
                        </li>
                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                How does MVP creation work?</a>
                               <ul class="accordion-content">
                                 <li>Stage of discovery</li>
                                 <li>Stage of product design</li>
                                 <li>Stage of product development</li>
                                 <li>Stage of product support</li>
                               </ul>
                        </li>
                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                Do you provide flexible, affordable solutions for MVP Development?</a>
                            <p class="accordion-content">Members of our MVP Development team can adapt to changes in the industry and are receptive to new learnings. As a result, we promise to provide you with the most flexible solutions at a reasonable price.<p>
                        </li>
                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                What happens if I'm not satisfied with the hired team's performance?
                            </a>
                            <p class="accordion-content">During the project engagement, you will have complete control of hiring and selecting our employees according to your project's needs. If you encounter any performance issues with our team, you can report them to our company. We'll make an effort to identify the problems and fix them.</p>
                        </li>
                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                Which sectors does your company offer services in? </a>
                            <p class="accordion-content">We are utilized by a wide range of sectors worldwide. We create software using effective technology and adhering to the most current standards for education, logistics, e-commerce, entertainment, fashion, and healthcare industries.<p>
                        </li>
                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                Do you work for new businesses in other Countries?
                            </a>
                            <p class="accordion-content">Yes, we offer services to all types of businesses in other Countries, from small start-ups to large corporations. Already we have clients from Australia, UAE, UK, USA, and Singapore.</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                Does your company provide maintenance services for MVP Development?
                            </a>
                            <p class="accordion-content">Our MVP development services don't end with launching. We keep in touch with you and are prepared to assist with repairs or upgrades.<p>
                         
                        </li>
                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>                              
                                Do you have an example of an MVP that eventually became a real-time application?
                            </a>
                            <p class="accordion-content">There are many applications. For instance, Amazon is undoubtedly one of the most profitable, most minor viable products that have evolved tremendously.<p>
                        </li>
                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>                              
                                How is MVP development carried out at your business?</a>
                            <p class="accordion-content">Developing MVP software in our company involves researching the market to learn how well your concept or offering may connect with potential clients. We consider customers' specific uses for the product or service, their top needs, and how the new product might meet the requirements during this process.<p>
                        </li>
                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>                              
                                How much does creating an MVP cost?
                            </a>
                            <p class="accordion-content">The price will vary based on the project's specifications and scope. You can get a quotation from us for our services. Based on the project's goals and requirements, the estimation varies.<p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="faq-contact">
            <div class="section-title">
                <div class="content">
                    <span>Message Us</span>
                    <h2>Do You Have Any Questions</h2>
                </div>
            </div>

            <div class="faq-contact-form">
                <form id="contactForm">
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="form-group mb-3">
                                <input type="text" name="name" id="name" class="form-control" placeholder="Name">
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6">
                            <div class="form-group mb-3">
                                <input type="email" name="email" id="email" class="form-control" placeholder="Email">
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6">
                            <div class="form-group mb-3">
                                <input type="text" name="phone_number" id="phone_number" class="form-control" placeholder="Phone">
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6">
                            <div class="form-group mb-3">
                                <input type="text" name="msg_subject" id="msg_subject" class="form-control" placeholder="Subject">
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <div class="form-group mb-3">
                                <textarea name="message" class="form-control" id="message" cols="30" rows="5" placeholder="Your Message"></textarea>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <button type="submit" class="btn btn-primary">Send Message</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>
<section class="team-area ptb-110">
    <div class="container">
        <div class="section-title">
            <div class="content">
                <h2>Mvp development - chennai</h2>
                <p>Business executives and the analyst team will oversee the entire project, considering all needs and assembling the development team. We will assist you till the project is completed. We provide you with the best MVP development team to change a project into a real-time application. The primary advantage of an MVP is that it prevents working capital from being lost by gathering essential data before the product finishes, is promoted, and is released to the public. When an MVP is made accessible to end users, the clients are allowed to evaluate their project's progress. MVP helps you find value propositions, reduce software development costs, and get the funding you need from investors. To ensure that the project is well-planned, usable, and prepared for launch, Techno Tackle can help you estimate the costs associated with developing the MVP. We'll help you through every step if you want to order MVP development. To ensure the quality of the finished product, we offer the Best MVP development results. MVP development services have been provided by Techno Tackle to clients in a variety of sectors worldwide.</p>
            </div>

            <div class="image">
                <img src="assets/img/section-title/section-title4.png" alt="image">
            </div>
        </div>

  
    </div>

    <div class="shape13"><img src="assets/img/shape/shape13.svg" alt="image"></div>
    <div class="shape14"><img src="assets/img/shape/shape13.svg" alt="image"></div>
</section> -->